import React, { FC } from 'react';
import GridContainer from 'components/redesign/GridContainer';
import KpiContainer from 'components/redesign/KpiContainer';
import StackedMutiColumnBarChart from 'components/StackedMultiColumnBarChart';
import NoDataFound from 'components/ErrorHandling/NoDataFound';
import * as Styled from './style'; // Optional: If you have related styles
// You can also import additional types if needed

interface BarChartViewProps {
  chartData: any; // Replace `any` with a proper type if available
  isLoading: boolean;
  mode: string;
}

const BarChartView: FC<BarChartViewProps> = ({
  chartData,
  isLoading,
  mode,
}) => {
  // If there's no data (or no metricsData), show NoDataFound
  if (
    !chartData ||
    !chartData.metricsData ||
    chartData.metricsData.length === 0
  ) {
    return (
      <Styled.NoDataFoundContainer themeMode={mode}>
        <div className="noDataFound">
          <NoDataFound />
        </div>
      </Styled.NoDataFoundContainer>
    );
  }

  return (
    <GridContainer>
      {chartData?.metricsData?.map((metric) => (
        <KpiContainer
          key={metric.metricId}
          isLoading={isLoading}
          title={metric.metricName}
        >
          {metric.chartOptions.series?.length > 0 ? (
            <StackedMutiColumnBarChart
              legend={{
                bottom: 0,
                right: 0,
                show: metric.chartOptions.legend.show,
              }}
              xAxis={{
                type: 'category',
                data: metric.chartOptions.xAxis.data,
                axisTick: metric.chartOptions.xAxis.axisTick,
              }}
              yAxis={metric.chartOptions.yAxis}
              seriesData={metric.chartOptions.series}
              grid={{
                left: '3%',
                right: '4%',
                bottom: '17%',
                top: '8%',
                containLabel: true,
              }}
              tooltip={metric.chartOptions.tooltip}
              eChartHeight={250}
            />
          ) : (
            <Styled.NoDataFoundContainer themeMode={mode}>
              <div className="noDataFound">
                <NoDataFound />
              </div>
            </Styled.NoDataFoundContainer>
          )}
        </KpiContainer>
      ))}
    </GridContainer>
  );
};

export default BarChartView;
